import bus from './bus'
import parent from './parent'
import driver from './driver'
import subdriver from './subdriver'
import place from './place'
import pickuproute from './pickuproute'
import droproute from './droproute'
import student from './student'
import adminnotification from './adminnotification'
import parentnotificationtemplate from './parentnotificationtemplate'
import busnotificationtemplate from './busnotificationtemplate'
import classroom from './classroom'
import notificationgroup from './notificationgroup'
import notification from './notification'
import schedule from './schedule'
import settingschool from './settingschool'
import admin from './admin'
import attachmentfile from './attachmentfile'
import login from './login'
import dayOff from './day-off'
import CategoriesFile from './categoriesFile'
import pickupTemplate from './pickupTemplate'
import logs from './logs'
import termUser from './termUser'
export default {
  bus,
  parent,
  driver,
  subdriver,
  pickuproute,
  droproute,
  place,
  student,
  classroom,
  adminnotification,
  parentnotificationtemplate,
  busnotificationtemplate,
  notificationgroup,
  notification,
  schedule,
  settingschool,
  admin,
  attachmentfile,
  login,
  dayOff,
  CategoriesFile,
  pickupTemplate,
  logs,
  termUser
}
